import { cookies } from '@jotta/utils/cookie'

const cookieName = 'login_state_installation_code'
const cookieOptions = {
  maxAge: 30 * 60,
  path: '/',
}

export function persistInstallationCode(installationCode: string | undefined) {
  if (installationCode) {
    cookies.set(cookieName, installationCode, cookieOptions)
  } else {
    cookies.remove(cookieName, cookieOptions)
  }
}

export function getInstallationCode() {
  return cookies.get(cookieName)
}
